import type React from "react"
import { memo } from "react"
import { twMerge } from "tailwind-merge"

type SectionHeaderProps = {
  label: string
  description?: string
  actionBtnLabel?: string
  actionBtnEvent?(): void
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ label, description, actionBtnLabel, actionBtnEvent }) => {
  return (
    <div className="pt-4 px-4 lg:pt-10 lg:pb-0 lg:px-[80px]">
      <div className={twMerge(actionBtnEvent && actionBtnLabel ? "flex items-center justify-between" : "block")}>
        <span className="text-pn-body-large-emphasis md:text-pn-headline-emphasis">{label}</span>
        {actionBtnEvent && actionBtnLabel && (
          <button className="btn-primary-xs" onClick={actionBtnEvent}>
            {actionBtnLabel}
          </button>
        )}
      </div>
      {description && <span className="text-pn-callout-regular">{description}</span>}
    </div>
  )
}
export default memo(SectionHeader)
